import { render, staticRenderFns } from "./JewelsMeaasge.vue?vue&type=template&id=125c3c8b&scoped=true&"
import script from "./JewelsMeaasge.vue?vue&type=script&lang=js&"
export * from "./JewelsMeaasge.vue?vue&type=script&lang=js&"
import style0 from "./JewelsMeaasge.vue?vue&type=style&index=0&id=125c3c8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125c3c8b",
  null
  
)

export default component.exports